import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import CatalogPage from './components/CatalogPage';
import MapPage from './components/MapPage';
import AboutPage from './components/AboutPage';
import ContributePage from './components/ContributePage';
import TraveloguePage from './components/TraveloguePage';
import TripReportPage from './components/TripReportPage';
import 'mapbox-gl/dist/mapbox-gl.css';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/catalog" element={<CatalogPage />} />
        <Route path="/map" element={<MapPage />} />
        <Route path="/travelogue" element={<TraveloguePage />} />
        <Route path="/travelogue/:slug" element={<TripReportPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contribute" element={<ContributePage />} />
      </Routes>
    </Router>
  );
}

export default App;